<template lang="html">
  <section class="about">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-8 mx-auto">
					<h2 id="about" class="text-center">About Me</h2>
					<p>I am a front-end web developer with an academic background in Political Science and International Relations. I got my start working in non-profit/association special projects and quickly realized that I excelled most when using code to make things more beautiful and efficient.</p>

					<p>3+ year experience in HTML, CSS, JavaScript, PHP, SQL, Git with working knowledge of WordPress development.</p>

					<p>Currently working as a front-end developer at <a href="seattlewebdesign.com" target="_blank">efelle creative</a>, a digital agency located on the waterfront in downtown Seattle. I'm interested in collaboration and focusing on making more accessible web experiences for all users.</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: "about"
};
</script>
